'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PriceDisplay from 'pricing-pages-unified-ui/components/common/pricing/PriceDisplay';
import UILink from 'UIComponents/link/UILink';
const CrossedOutPrice = styled(PriceDisplay).withConfig({
  displayName: "RequiredOnboardingSubtext__CrossedOutPrice",
  componentId: "sc-19boft0-0"
})(["text-decoration:line-through;"]);
const BringAttention = styled.b.withConfig({
  displayName: "RequiredOnboardingSubtext__BringAttention",
  componentId: "sc-19boft0-1"
})([""]);

const RequiredOnboardingSubtext = ({
  langKey,
  pricingInfo,
  currencyCode
}) => {
  if (pricingInfo.oneTimeFee.fullPrice > pricingInfo.oneTimeFee.calculatedPrice) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.planBuilder.requiredOnboardingSubtext.${langKey}-with-discount_jsx`,
        options: {
          currencyCode,
          fullPrice: pricingInfo.oneTimeFee.fullPrice,
          discountedPrice: pricingInfo.oneTimeFee.calculatedPrice
        },
        elements: {
          PriceDisplay,
          CrossedOutPrice,
          UILink,
          b: BringAttention
        }
      })
    });
  }

  return /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `pricingPage.planBuilder.requiredOnboardingSubtext.${langKey}_jsx`,
      options: {
        currencyCode,
        price: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay,
        UILink,
        b: BringAttention
      }
    })
  });
};

export default RequiredOnboardingSubtext;